/**
 * 数据存储API
 * */
import cookies from 'vue-cookies'; // 存储cookie

export default {
  /**************** 存储 Cookie ****************/
  // return false or true
  isCookieKey(keyName) {
    return cookies.isKey(keyName);
  },
  // return this 默认为1天过期
  setCookie(keyName, value, options = {}) {
    return cookies.set(keyName, value, { expires: options.expires || '1D', path: options.path || '' });
  },
  // return value
  getCookie(keyName) {
    return cookies.get(keyName);
  },
  // return a array
  getCookieKeys(keyName) {
    return cookies.keys(keyName);
  },
  // return false or true
  removeCookie(keyName) {
    return cookies.remove(keyName);
  },

  /**************** 存储 localStorage ****************/
  setLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  getLocalStorage(key) {
    let data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  },
  removeLocalStorage(key) {
    key ? localStorage.removeItem(key) : localStorage.removeItem();
  },
  clearLocalStorage() {
    localStorage.clear();
  },

  /**************** 存储 sessionStorage ****************/
  setSessionStorage(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  getSessionStorage(key) {
    let data = sessionStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  },
  removeSessionStorage(key) {
    key ? sessionStorage.removeItem(key) : sessionStorage.removeItem();
  },
  clearSessionStorage() {
    sessionStorage.clear();
  }
};
